import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"usage\"><a href=\"#usage\"></a> Usage </h1><div class=\"py-5\"> Use Font Awesome icons with spesific class as explained in the <a class=\"fw-bold\" href=\"https://fontawesome.com/icons/affiliatetheme?style=brands\" target=\"_blank\">Icon Preview Page</a>: </div><div class=\"py-5\"><div class=\"rounded border d-flex flex-wrap p-10\"><i class=\"fas fa-envelope-open-text fs-2x me-15\"></i><i class=\"fab fa-affiliatetheme fs-2x me-15\"></i><i class=\"fas fa-mail-bulk fs-2x me-15\"></i><i class=\"fas fa-coins fs-2x me-15\"></i><i class=\"fas fa-chart-pie fs-2x me-15\"></i><i class=\"fas fa-percentage fs-2x me-15\"></i><i class=\"fas fa-print fs-2x me-15\"></i><i class=\"fas fa-pen-nib fs-2x me-15\"></i></div></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<i class="fas fa-envelope-open-text fs-2x me-15"></i>
        <i class="fab fa-affiliatetheme fs-2x me-15"></i>
        <i class="fas fa-mail-bulk fs-2x me-15"></i>
        <i class="fas fa-coins fs-2x me-15"></i>
        <i class="fas fa-chart-pie fs-2x me-15"></i>
        <i class="fas fa-percentage fs-2x me-15"></i>
        <i class="fas fa-print fs-2x me-15"></i>
        <i class="fas fa-pen-nib fs-2x me-15"></i>`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}